import {
  // MURUCA
  MrSearchLayoutComponent,
  MrResourceLayoutComponent,
  // OTHER
  LocaleDependenciesGuard,
  MrItineraryLayoutComponent,
} from '@net7/boilerplate-muruca';

type RouteConfig = {
  component?: any;
  paths: {
    [locale: string]: string;
  };
  data?: any;
  isRedirect?: boolean;
  redirectTo?: {
    [locale: string]: string;
  };
}

const config: {
  [layoutID: string]: RouteConfig;
} = {
  editions: {
    component: MrSearchLayoutComponent,
    paths: {
      en: 'editions'
    },
    data: { configId: 'search-editions' },
  },
  edition: {
    component: MrResourceLayoutComponent,
    paths: {
      en: 'edition/:id/:slug'
    },
    data: { configId: 'resource-edition' },
  },
  itinerary: {
    component: MrItineraryLayoutComponent,
    paths: {
      en: 'itinerary/:id/:slug'
    },
    data: { configId: 'itinerary' },
  },  
  // home: {
  //   component: MrHomeLayoutComponent,
  //   paths: {
  //     // it: '',
  //     en: ''
  //   },
  //   isRedirect: true,
  // },
};

const APP_ROUTES: any = [
  {
    path: '',
    redirectTo: 'editions',
    pathMatch: 'full',
    data: { configId: 'search-editions' }
  }
];

// Generate angular routes from config
Object.keys(config).forEach((routeId) => {
  const {
    component, data, paths, isRedirect, redirectTo
  } = config[routeId];
  Object.entries(paths).forEach(([locale, path]) => {
    // path to component
    if (component) {
      APP_ROUTES.push({
        path,
        component,
        data: { ...data, routeId, locale },
        canActivate: [LocaleDependenciesGuard]
      });
    }
    // catch route
    if (isRedirect) {
      APP_ROUTES.push(
        {
          path,
          redirectTo: redirectTo ? redirectTo[locale] : `${path}/`,
          data: { ...data, routeId, locale },
        }
        );
      }
    });
  });
  
  export { APP_ROUTES };

  // // default route handler
  // APP_ROUTES.push(
  //   {
  //     path: '**',
  //     component: MrStaticLayoutComponent,
  //     data: {
  //       notFoundPath: NOT_FOUND_PATH,
  //       locale: 'it'
  //     },
  //     canActivate: [LocaleDependenciesGuard]
  //   },
  //   {
  //     path: NOT_FOUND_PATH,
  //     component: Page404LayoutComponent,
  //     data: { id: 'page-404', locale: 'it' },
  //     canActivate: [LocaleDependenciesGuard]
  //   }
  // );
